"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RELOAD_PROPERTY_ITEM_OPTIONS = exports.GET_OPTIONS_PROMISE = exports.OPEN_EVENT = exports.OPEN = exports.ON_POPOVER_ITEM_CLICK = exports.OPEN_COLLECTION = exports.ON_COLLECTION_VALUE_CHANGED = exports.ON_VALUE_CHANGED = exports.RELOAD = exports.LOAD = void 0;
exports.LOAD = 'PROPERTY_INSPECTOR.LOAD';
exports.RELOAD = 'PROPERTY_INSPECTOR.RELOAD';
exports.ON_VALUE_CHANGED = 'PROPERTY_INSPECTOR.ON_VALUE_CHANGED';
exports.ON_COLLECTION_VALUE_CHANGED = 'PROPERTY_INSPECTOR.ON_COLLECTION_VALUE_CHANGED';
exports.OPEN_COLLECTION = 'PROPERTY_INSPECTOR.ON_COLLECTION_OPEN';
exports.ON_POPOVER_ITEM_CLICK = 'PROPERTY_INSPECTOR.ON_POPOVER_ITEM_CLICK';
exports.OPEN = 'PROPERTY_INSPECTOR.OPEN';
exports.OPEN_EVENT = 'PROPERTY_INSPECTOR.ON_EVENT_TRIGGER';
exports.GET_OPTIONS_PROMISE = 'PROPERTY_INSPECTOR.GET_OPTIONS_PROMISE';
exports.RELOAD_PROPERTY_ITEM_OPTIONS = 'PROPERTY_INSPECTOR.RELOAD_PROPERTY_ITEM_OPTIONS';
//# sourceMappingURL=actionTypes.js.map